import React, { useState } from 'react';
import { Shirt, Bell, Star } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { sendFormData } from '../utils/sendForm';
import Notification from './Notification';
import './Merch.css';

const Merch = () => {
  const [notification, setNotification] = useState({ show: false, type: 'success', title: '', message: '' });
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    try {
      await sendFormData({ type: 'merch-newsletter', ...data }, 'merch');
      reset();
      setNotification({
        show: true,
        type: 'success',
        title: 'Inscription confirmée !',
        message: 'Vous serez parmi les premiers à découvrir notre collection Pinky Merch !'
      });
      setTimeout(() => {
        setNotification({ show: false, type: 'success', title: '', message: '' });
      }, 8000);
    } catch (e) {
      setNotification({
        show: true,
        type: 'error',
        title: 'Erreur lors de l\'inscription',
        message: 'Une erreur est survenue. Réessayez plus tard.'
      });
    }
  };



  return (
    <section id="merch" className="merch section">
      <div className="container">
        <div className="merch-header">
          <h2 className="section-title">
            <Shirt className="title-icon" size={40} />
            Pinky Merch
          </h2>
          <p className="section-subtitle animated-subtitle">
            Bientôt disponible ! Portez l'univers Pinky Cloud avec style 
          </p>
          <div className="coming-soon-badge">
            <Star size={16} />
            Lancement prévu bientôt
            <Star size={16} />
          </div>
        </div>



        {/* Newsletter pour être notifié */}
        <div className="notification-section">
          <div className="notification-content">
            <div className="notification-info">
              <h3>
                <Bell size={24} />
                Soyez les premiers informés !
              </h3>
              <p>
                Inscrivez-vous à notre newsletter pour être notifié dès le lancement de notre collection 
                Pinky Merch.
              </p>
              
              <div className="benefits">
                <div className="benefit">
                  <span className="benefit-icon">✨</span>
                  <span>Accès prioritaire aux nouveautés</span>
                </div>
                {/* Avantage promo retiré */}
                <div className="benefit">
                  <span className="benefit-icon">📦</span>
                  <span>Livraison gratuite dès 50€ d'achat</span>
                </div>
                <div className="benefit">
                  <span className="benefit-icon">💖</span>
                  <span>Contenus exclusifs et surprises</span>
                </div>
              </div>
            </div>

            <div className="notification-form-container">
              <form onSubmit={handleSubmit(onSubmit)} className="notification-form">
                <input type="text" name="website" style={{display:'none'}} aria-hidden="true" tabIndex="-1" />
                <h4>Restez informé</h4>
                
                <div className="form-group">
                  <label className="form-label">Prénom *</label>
                  <input
                    type="text"
                    {...register('firstName', { required: 'Prénom requis' })}
                    className="form-input"
                    placeholder="Votre prénom"
                  />
                  {errors.firstName && <span className="form-error">{errors.firstName.message}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    {...register('email', { 
                      required: 'Email requis',
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: 'Email invalide'
                      }
                    })}
                    className="form-input"
                    placeholder="votre.email@exemple.com"
                  />
                  {errors.email && <span className="form-error">{errors.email.message}</span>}
                </div>

                <div className="form-group">
                  <label className="form-label">Produits qui vous intéressent</label>
                  <div className="checkboxes">
                    <label className="checkbox-item">
                      <input type="checkbox" {...register('interests')} value="tshirts" />
                      <span className="checkmark"></span>
                      T-shirts & Tops
                    </label>
                    <label className="checkbox-item">
                      <input type="checkbox" {...register('interests')} value="hoodies" />
                      <span className="checkmark"></span>
                      Sweats & Hoodies
                    </label>
                    <label className="checkbox-item">
                      <input type="checkbox" {...register('interests')} value="accessories" />
                      <span className="checkmark"></span>
                      Accessoires
                    </label>
                    <label className="checkbox-item">
                      <input type="checkbox" {...register('interests')} value="all" />
                      <span className="checkmark"></span>
                      Toute la collection
                    </label>
                  </div>
                </div>

                <button type="submit" className="btn btn-primary btn-large notification-btn">
                  <Bell size={20} />
                  Me notifier du lancement
                </button>

                <p className="form-disclaimer">
                  En vous inscrivant, vous acceptez de recevoir nos newsletters. 
                  Vous pouvez vous désabonner à tout moment.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      <Notification
        show={notification.show}
        type={notification.type}
        title={notification.title}
        message={notification.message}
        onClose={() => setNotification({ show: false, type: 'success', title: '', message: '' })}
      />
    </section>
  );
};

export default Merch; 